<template>
  <div class="pricingPlan">
    <section class="page page1">
      <div class="title">{{$t('buy.slogan')}}</div>

      <template v-if="viewAllPlans">
        <div class="subtitle">{{$t('buy.slogan2')}}</div>
      </template>
      <template v-else>
        <div class="subtitle">{{$t('buy.slogan3').replace('%s', '50%')}}</div>
      </template>

      <div class="plans" :class="{ viewAllPlans }">
        <template v-for="(plan, i) in plans">
          <div
            class="plan"
            :class="{ plus: plan.name.indexOf('plus') > 0, choosed: choosedIndex === i }"
            @click="planChooseHandle(i)"
            :key="i">
            <img v-show="choosedIndex === i" class="choosedIcon" src="@/assets/images/pricing/choosed.png" alt="choosedIcon">
            <div v-show="plan.tag" class="planTag">{{$t(`buy.${plan.tag}`)}}</div>
            <div class="row">
              <div class="group">
                <div class="planName">{{$t(`buy.${plan.name}`)}}</div>
                <div class="planDuration">{{$t(`buy.%s_months`).replace('%s', plan.durationMonths)}}</div>
              </div>
              <div class="group">
                <div class="planDiscountPrice">{{plan.discountPrice}}</div>
                <div class="planOriginalPrice">{{plan.originalPrice}}</div>
              </div>
            </div>
            <div class="planContent">
              <div class="planContentIcon">
                <svg t="1684218579546" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2458" width="16" height="16"><path d="M882.234 219.695c18.742-18.75 49.134-18.755 67.883-0.013 18.56 18.554 18.752 48.527 0.569 67.316l-0.557 0.566-514.182 514.37c-18.546 18.554-48.504 18.754-67.296 0.59l-0.566-0.557-293.818-293.37c-18.76-18.731-18.783-49.123-0.052-67.883 18.543-18.572 48.516-18.78 67.316-0.608l0.566 0.556 259.87 259.475 480.267-480.442z" fill="#8292B9" p-id="2459"></path></svg>
              </div>
              <div class="planContentText">{{$t('buy.unlock_all_clips_courses_ebooks_games')}}</div>
            </div>
            <div class="planContent">
              <div class="planContentIcon">
                <svg t="1684218579546" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2458" width="16" height="16"><path d="M882.234 219.695c18.742-18.75 49.134-18.755 67.883-0.013 18.56 18.554 18.752 48.527 0.569 67.316l-0.557 0.566-514.182 514.37c-18.546 18.554-48.504 18.754-67.296 0.59l-0.566-0.557-293.818-293.37c-18.76-18.731-18.783-49.123-0.052-67.883 18.543-18.572 48.516-18.78 67.316-0.608l0.566 0.556 259.87 259.475 480.267-480.442z" fill="#8292B9" p-id="2459"></path></svg>
              </div>
              <div class="planContentText" v-html="getAICreditsTrans(plan.AICredits)"></div>
            </div>
          </div>
        </template>
      </div>

      <div class="AlCreditsLink" @click="maskShow=true">{{$t('buy.what_are_ai_credits')}}</div>
      <div class="buyBtn" @click="buyHandle" v-loading="buyBtnLoading">{{$t('buy.start_1_week_free_trial')}}</div>
      <div v-show="viewAllPlans" class="viewAllPlansLink" @click="viewAllPlans=false">{{$t('buy.view_all_plans')}}<svg t="1684229830362" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2282" width="16" height="16"><path d="M731.733333 480l-384-341.333333c-17.066667-14.933333-44.8-14.933333-59.733333 4.266666-14.933333 17.066667-14.933333 44.8 4.266667 59.733334L640 512 292.266667 821.333333c-17.066667 14.933333-19.2 42.666667-4.266667 59.733334 8.533333 8.533333 19.2 14.933333 32 14.933333 10.666667 0 19.2-4.266667 27.733333-10.666667l384-341.333333c8.533333-8.533333 14.933333-19.2 14.933334-32s-4.266667-23.466667-14.933334-32z" fill="#ffffff" p-id="2283"></path></svg></div>
    </section>

    <section class="page page2">
      <div class="title">{{$t('buy.slogan2')}}</div>
      <div class="introItems">
        <div class="introItem">
          <div class="introWrap">
            <div class="introTitle">
              <img class="introIcon" src="@/assets/images/pricing/introIcon1.png" alt="introduceIcon">
              <div class="introTitleText">{{$t('buy.selling_point_title_1')}}</div>
            </div>
            <div class="introContent">{{getLearningLangTrans()}}</div>
          </div>
          <img class="introImg" src="@/assets/images/pricing/introImg1.png" alt="introduceImage">
        </div>
        <div class="introItem reverse">
          <div class="introWrap">
            <div class="introTitle">
              <img class="introIcon" src="@/assets/images/pricing/introIcon2.png" alt="introduceIcon">
              <div class="introTitleText">{{$t('buy.selling_point_title_2')}}</div>
            </div>
            <div class="introContent">{{$t('buy.selling_point_content_2')}}</div>
          </div>
          <img class="introImg" src="@/assets/images/pricing/introImg2.png" alt="introduceImage">
        </div>
        <div class="introItem">
          <div class="introWrap">
            <div class="introTitle">
              <img class="introIcon" src="@/assets/images/pricing/introIcon3.png" alt="introduceIcon">
              <div class="introTitleText">{{$t('buy.selling_point_title_3')}}</div>
            </div>
            <div class="introContent">{{$t('buy.selling_point_content_3')}}</div>
          </div>
          <img class="introImg" src="@/assets/images/pricing/introImg3.png" alt="introduceImage">
        </div>
      </div>
      <div class="buyBtn" @click="buyHandle">{{$t('buy.start_1_week_free_trial')}}</div>
    </section>

    <section class="page page3">
      <div class="tryWrap">
        <div class="tryLeftWrap">
          <div class="tryText1">{{$t('buy.expire_remind_title')}}</div>
          <div class="tryText2" v-html="getExpireRemindTrans()"></div>
          <div class="tryText3">{{$t('buy.expire_remind_content')}}</div>
        </div>
        <div class="tryRightWrap">
          <div class="tryItems">
            <div class="tryItem">
              <img class="itemIcon" src="@/assets/images/pricing/tryIcon1.png" alt="tryIcon">
              <div class="itemWrap">
                <div class="tryTitle">{{$t('buy.today')}}</div>
                <div class="tryContent">{{$t('buy.day_content_1')}}</div>
              </div>
              <div class="dotted"></div>
            </div>
            <div class="tryItem">
              <img class="itemIcon" src="@/assets/images/pricing/tryIcon2.png" alt="tryIcon">
              <div class="itemWrap">
                <div class="tryTitle">{{$t('buy.day%s').replace('%s', '5')}}</div>
                <div class="tryContent">{{$t('buy.day_content_2')}}</div>
              </div>
              <div class="dotted"></div>
            </div>
            <div class="tryItem">
              <img class="itemIcon" src="@/assets/images/pricing/tryIcon3.png" alt="tryIcon">
              <div class="itemWrap">
                <div class="tryTitle">{{$t('buy.day%s').replace('%s', '7')}}</div>
                <div class="tryContent">{{getExpireDateTrans()}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="mask" v-show="maskShow" @click="maskShow=false">
      <div class="AlCreditsWindow" @click.stop>
        <img @click="maskShow=false" class="closeImg" src="@/assets/images/clips/lesson/close.png" alt="close">
        <div class="windowTitle">{{$t('buy.what_are_ai_credits')}}</div>
        <div class="windowContent">
          {{$t('buy.ai_credits_introduce')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vuex from 'vuex'
  import { getPlans } from '@/api/order'
  import constants from '@/utils/constants'

  export default {
    data() {
      return {
        choosedIndex: 0,
        viewAllPlans: true,
        maskShow: false,
        buyBtnLoading: false,
        plans: [
          {
            plan: 'FluenDay Premium - Yearly',
            name: 'premium',
            durationMonths: '12',
            originalPrice: '',
            discountPrice: '',
            AICredits: '2,000',
            tag: 'most_popular'
          },
          {
            plan: 'FluenDay Premium - Monthly',
            name: 'premium',
            durationMonths: '1',
            originalPrice: '',
            discountPrice: '',
            AICredits: '2,000',
            tag: ''
          },
          {
            plan: 'FluenDay Premium Plus - Yearly',
            name: 'premium_plus',
            durationMonths: '12',
            originalPrice: '',
            discountPrice: '',
            AICredits: '10,000',
            tag: 'most_powerful'
          },
          {
            plan: 'FluenDay Premium Plus - Monthly',
            name: 'premium_plus',
            durationMonths: '1',
            originalPrice: '',
            discountPrice: '',
            AICredits: '10,000',
            tag: ''
          }
        ]
      }
    },
    inject: ['signIn'],
    computed: {
      ...Vuex.mapGetters(['userLanguage', 'userInfo', 'productsInfo'])
    },
    mounted() {
      this.init()
    },
    methods: {
      async init() {
        let productsInfo

        if (this.productsInfo) {
          productsInfo = this.productsInfo
        } else {
          let loading = this.$loading()
          productsInfo = await getPlans('')
          loading.close()
        }

        let products = productsInfo.products
        for (let planData of this.plans) {
          let currentPlan = products.find(product => product.user_selected_plan === planData.plan)
          planData.originalPrice = currentPlan.user_original_price.split('/')[0]
          planData.discountPrice = currentPlan.user_your_price.split('/')[0]
        }
      },
      async buyHandle() {
        if (this.userInfo) {
          if (!this.productsInfo) {
            this.buyBtnLoading = true
            let productsInfo = await getPlans(this.userInfo.UID)
            this.$store.commit('set_productsInfo', productsInfo)
            this.buyBtnLoading = false
          }

          let userSelectedPlan = this.plans[this.choosedIndex]
          let orderInfo = this.productsInfo.products.find(item => item.user_selected_plan === userSelectedPlan.plan)
          this.$router.push({ name: 'PricingOrder', params: { orderInfo } })
        } else {
          this.signIn()
        }
      },
      planChooseHandle(index) {
        this.choosedIndex = index
      },
      getAICreditsTrans(AICredits) {
        return this.$t('buy.%s_ai_credits_per_month').replace('%s', `<span class="AINum">${AICredits}</span>`)
      },
      getLearningLangTrans() {
        return this.$t('buy.selling_point_content_1').replace('%s', constants.langsData['en']['fullName'])
      },
      getExpireRemindTrans() {
        let daysVar = this.$t('buy.%sdays')
        let replaceTxt = daysVar.replace('%s', '2')
        return this.$t('buy.expire_remind_subtitle').replace(daysVar, `<span class="highlight">${replaceTxt}</span>`)
      },
      getExpireDateTrans() {
        let now = new Date().getTime()
        let day7 = 1000 * 3600 * 24 * 7
        let expireDate = new Date(now + day7)
        let expireDateDay = expireDate.getDate()
        let expireDateMonth = expireDate.getMonth() + 1
        let expireDateTrans =  this.$t(`buy.month_${expireDateMonth}`).replace('%s', expireDateDay)
        return this.$t('buy.day_content_3').replace('%d', expireDateTrans)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .pricingPlan {
    .page {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .buyBtn {
      margin-top: 16px;
      padding: 0 50px;
      min-width: 260px;
      height: 40px;
      line-height: 40px;
      border-radius: 40px;
      background: #FFE113;
      box-shadow: 0 5px 10px 0 #00000024;
      font-family: Helvetica;
      font-weight: 700;
      font-size: 16px;
      color: #000000;
      overflow: hidden;
      text-align: center;
      box-sizing: border-box;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        background: #FFCA13;
      }
    }
    .mask {
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      z-index: 1001;
      width: 100vw;
      height: 100vh;
      left: 0;
      top: 0;
      background: #00000045;
      .AlCreditsWindow {
        padding: 36px;
        position: relative;
        background: #FFFFFF;
        border-radius: 6px;
        max-width: 600px;
        box-sizing: border-box;
        .closeImg {
          position: absolute;
          top: 14px;
          right: 14px;
          width: 14px;
          cursor: pointer;
        }
        .windowTitle {
          font-family: Helvetica;
          font-weight: 700;
          font-size: 20px;
          color: #09123B;
          text-align: center;
        }
        .windowContent {
          margin-top: 20px;
          font-family: Roboto;
          font-weight: 400;
          font-size: 14px;
          color: #09123B;
          white-space: pre-line;
        }
      }
    }
    .page1 {
      position: relative;
      padding-top: 80px;
      padding-bottom: 60px;
      .title {
        font-weight: 900;
        font-size: 30px;
        color: #FFFFFF;
      }
      .subtitle {
        margin-top: 20px;
        font-weight: 500;
        font-size: 22px;
        color: #FFFFFF;
      }
      .plans {
        margin-top: 60px;
        width: 1000px;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        &.viewAllPlans {
          width: 700px;
          .plan {
            width: 300px;
            &.choosed {
              width: 320px;
            }
          }
          .plan:nth-child(2n) {
            display: none;
          }
        }
        .plan {
          position: relative;
          padding: 20px 10px;
          width: 220px;
          border: 4px solid transparent;
          border-radius: 16px;
          background-clip: padding-box, border-box;
          background-origin: padding-box, border-box;
          background-image: linear-gradient(to right, #fff, #fff), linear-gradient(90deg, #66C0FF, #6FF8FF);
          opacity: 0.9;
          cursor: pointer;
          box-sizing: border-box;
          .row {
            margin-top: 20px;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
          }
          ::v-deep .AINum {
            font-weight: 500;
            color: #266BF5;
          }
          .choosedIcon {
            position: absolute;
            width: 28px;
            top: -14px;
            right: -14px;
          }
          .planTag {
            padding: 4px 14px;
            position: absolute;
            left: 0;
            top: 0;
            background-image: linear-gradient(90deg, #2562F1 0%, #2A7DFD 100%);
            border-radius: 12px 0 20px 0;
            font-family: Helvetica;
            font-weight: 700;
            font-size: 12px;
            color: #FFFFFF;
          }
          .planName {
            font-family: Roboto;
            font-weight: 700;
            font-size: 14px;
            color: #000000;
          }
          .planDuration {
            margin-top: 10px;
            font-family: Roboto;
            font-weight: 900;
            font-size: 12px;
            color: #000000;
          }
          .planDiscountPrice {
            font-family: Helvetica;
            font-weight: 700;
            font-size: 18px;
            color: #000000;
          }
          .planOriginalPrice {
            margin-top: 8px;
            font-family: Helvetica;
            font-weight: 500;
            font-size: 12px;
            color: #493F3F66;
            text-decoration: line-through;
          }
          .planContent {
            margin-top: 26px;
            display: flex;
            align-items: flex-start;
            &:last-child {
              margin-top: 10px;
            }
            .planContentIcon {
              padding: 1px;
            }
            .planContentText {
              margin-left: 5px;
              font-family: Roboto;
              font-weight: 400;
              font-size: 12px;
              color: #607296;
            }
          }

          &.plus {
            background-image: linear-gradient(to right, #fff, #fff), linear-gradient(90deg, #FFAF55, #FFE113);
            ::v-deep .AINum {
              color: #F47F2C;
            }
            .planTag {
              background-image: linear-gradient(90deg, #FF632D 0%, #FF9C1E 100%);;
            }
          }
          &.choosed {
            width: 240px;
            opacity: 1;
            .planName {
              font-size: 16px;
            }
            .planDuration {
              font-size: 14px;
            }
            .planDiscountPrice {
              font-size: 20px;
            }
            .planOriginalPrice {
              font-size: 14px;
            }
            .planContentText {
              font-size: 13px;
            }
          }
        }
      }
      .AlCreditsLink {
        margin-top: 30px;
        font-family: Roboto;
        font-style: italic;
        font-size: 16px;
        text-decoration: underline;
        color: #FFFFFF;
        opacity: 0.7;
        text-align: center;
        cursor: pointer;
      }
      .viewAllPlansLink {
        position: absolute;
        bottom: 20px;
        display: flex;
        align-items: center;
        font-family: Roboto;
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
        cursor: pointer;
        svg {
          margin-left: 10px;
        }
      }
    }
    .page2 {
      padding: 60px 0;
      background: #1C22B6;
      .title {
        font-weight: 900;
        font-size: 30px;
        color: #FFFFFF;
        text-align: center;
      }
      .introItems {
        margin-top: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .introItem {
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          min-width: 800px;
          &.reverse {
            flex-direction: row-reverse;
          }
          .introWrap {
            display: flex;
            flex-direction: column;
            max-width: 500px;
            .introTitle {
              display: flex;
              align-items: center;
              .introIcon {
                margin-right: 20px;
                width: 34px;
              }
              .introTitleText {
                font-weight: 700;
                font-size: 22px;
                color: #FFFFFF;
              }
            }
            .introContent {
              margin-top: 14px;
              margin-left: 54px;
              font-weight: 400;
              font-size: 18px;
              color: #FFFFFF;
              text-align: left;
              opacity: 0.8;
            }
          }
          .introImg {
            width: 200px;
          }
        }
      }
    }
    .page3 {
      padding: 80px 0;
      .tryWrap {
        display: flex;
        justify-content: center;
        .tryLeftWrap {
          max-width: 400px;
          ::v-deep .highlight {
            color: #FFE113;
          }
          .tryText1 {
            font-weight: 900;
            font-size: 30px;
            color: #FFFFFF;
          }
          .tryText2 {
            margin-top: 30px;
            font-weight: 700;
            font-size: 24px;
            color: #FFFFFF;
          }
          .tryText3 {
            margin-top: 20px;
            font-weight: Italic;
            font-size: 18px;
            color: #FFFFFF;
            opacity: 0.7;
          }
        }
        .tryRightWrap {
          margin-left: 100px;
          max-width: 300px;
          .tryItems {
            .tryItem {
              margin-top: 24px;
              display: flex;
              align-items: flex-start;
              position: relative;
              &:first-child {
                margin-top: 0;
              }
              .dotted {
                position: absolute;
                top: 30px;
                left: 14px;
                width: 1px;
                height: 100%;
                border-left: 3px dotted #5893FF;
              }
              .itemIcon {
                margin-right: 36px;
                width: 30px;
              }
              .itemWrap {
                .tryTitle {
                  font-weight: 700;
                  font-size: 16px;
                  color: #FFFFFF;
                }
                .tryContent {
                  margin-top: 5px;
                  font-weight: 500;
                  font-size: 13px;
                  color: #FFFFFF;
                  opacity: 0.8;
                }
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .pricingPlan {
      .mask {
        height: 100%;
      }
      .page {
        padding-left: 5vw;
        padding-right: 5vw;
        box-sizing: border-box;
      }
      .page1 {
        .plans {
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
          &.viewAllPlans {
            width: 100%;
          }
          .plan {
            margin-bottom: 20px;
            width: 100% !important;
          }
        }
      }
      .page2 {
        .title {
          text-align: left;
        }
        .introItems {
          .introItem {
            margin-bottom: 20px;
            min-width: unset;
            width: 100%;
            .introImg {
              display: none;
            }
          }
        }
      }
      .page3 {
        .tryWrap {
          flex-direction: column;
          .tryRightWrap {
            margin-left: 0;
            margin-top: 50px;
          }
        }
      }
    }
  }
</style>